import styles from "./index.module.less";
import classNames from "classnames";

export function TipMessage({ children }) {
  return (
    <div className={classNames(styles.tipMessage)}>
      <div>{children}</div>
    </div>
  );
}

export default function Wrapper({ message: { text } }) {
  return <TipMessage>{text}</TipMessage>;
}
